import { Injectable } from "@angular/core";
import { EntityQuery, iBisEntityService } from "@dohu/ibis-entity";
import { iBisFileService, iBisServerConfig } from "@dohu/ibis-common";
import { iBisAuthService, iBisSecureService } from "@dohu/ibis-auth";
import { DataService } from "../../service/data.service";

@Injectable()

export class WorkingScheduleService extends iBisSecureService {
    pId: string
    data: any;

    constructor(auth: iBisAuthService, entity: iBisEntityService, config: iBisServerConfig, protected file: iBisFileService,
        public ds: DataService) {
        super(auth, entity, config);
    }

    load(): void {
    }

    public set partyId(id: string) {
        this.pId = id;
    }

    getWorkingDays(partyId: string, userId?: string) {
        const q = new EntityQuery('WorkingSchedule').eq('partyId', partyId).addOrderBy(['weekDay']);
        q.eq('userId', userId ? userId : null);
        return this.entity.store(q, false, 'id').load();
    }

    addEditWorkingSchedule(obj: any, ws?: any) {
        if (ws && ws.id) {
            return this.entity.update('WorkingSchedule', ws.id, obj)
        } else {
            return this.entity.insert('WorkingSchedule', obj);
        }
    }

    public returnTime(time: any) {
        if (time) {
            const h = ('0' + new Date(time).getHours()).slice(-2);
            const m = ('0' + new Date(time).getMinutes()).slice(-2);
            return h + ':' + m;
        }
    }
}